import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { updateLastActivity } from "../../utils/sessionActivity";
import { persistAuthToken } from "../../utils/authTokenRefresh";
import { clearSuperAdminSessionStorage } from "../../utils/authSession";
import { axiosAuthDefaults } from "./axiosAuthConfig";

const superAdminAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  ...axiosAuthDefaults,
});

// Response Interceptor: Token süresi dolarsa super admin login'e yönlendir
superAdminAxiosInstance.interceptors.response.use(
  (response) => {
    persistAuthToken(response, "superAdminToken");
    updateLastActivity();
    return response;
  },
  (error) => {
    const url = error.config?.url || "";
    const isLoginEndpoint = url.includes("/login") || url.includes("/register") || url.includes("/verify-2fa");
    if (error.response && error.response.status === 401 && !isLoginEndpoint) {
      clearSuperAdminSessionStorage();
      window.location.href = "/super-admin/auth/secure-access/login";
    }
    return Promise.reject(error);
  }
);

export default superAdminAxiosInstance;

